import { calcAdherence } from './adherence';
import { buildSymptomTiming } from './symptomTiming';
import { normalizeFirm } from './recalls';

// Badges tied to vial records, adherence and symptom insights — all derived from data the badge
// effect already watches (vials, compounds, shots, check-ins), so none needs a persisted flag.
// Returns the ids earned right now; the caller skips ones already granted.
export const STEADY_HAND_MIN_SCHEDULED = 8;   // ~2 doses/week over 30 days, so a brand-new item can't earn it
export const STEADY_HAND_MIN_PCT = 90;

export function recallEraBadges({ stored, shots, checkIns, getCmpd, now = new Date() }) {
  const ids = [];
  const vials = Object.values(stored?.vials || {}).flat();

  // TOTAL RECALL — dealt with a recall: acknowledged an FDA alert ("I've seen this" / "Stop
  // using") or marked a vial recalled yourself.
  if (vials.some(v => v.recall || Object.keys(v.recallAcks || {}).length > 0)) ids.push('total_recall');

  // LOT KEEPER — lot # recorded on 5+ vials/bottles (the habit that makes recall matching exact).
  if (vials.filter(v => String(v.lot || '').trim()).length >= 5) ids.push('lot_keeper');

  // PHARMACIST — 3+ different pharmacies, compared the same way recall matching compares firms.
  if (new Set(vials.map(v => normalizeFirm(v.pharmacy)).filter(Boolean)).size >= 3) ids.push('pharmacist');

  // STEADY HAND — 90%+ adherence over the 30 days ending yesterday on a scheduled, active item.
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  const steady = Object.entries(stored?.compounds || {}).some(([key, c]) => {
    if (c.archived) return false;
    const r = calcAdherence({ compound: c, compoundKey: key, shots, start, end });
    return r.scheduled >= STEADY_HAND_MIN_SCHEDULED && r.pct >= STEADY_HAND_MIN_PCT;
  });
  if (steady) ids.push('steady_hand');

  // SYMPTOM SLEUTH — Symptom Timing (Trends) found at least one real pattern.
  if ((checkIns || []).length && buildSymptomTiming({ checkIns, shots, getCmpd }).insights.length > 0) ids.push('symptom_sleuth');

  return ids;
}
